import '../styles.css';
import { prop } from '@ipfabric/utils/fp/prop';
import { GraphBreadcrumbContainer } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbContainer';
import type { GraphBreadcrumbProps } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbProps';
import type {
  GraphBreadcrumbType,
  NetworkViewerModeBreadcrumb,
} from 'components/Graph/GraphBreadcrumbs/helpers/buildBreadcrumbs';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { loadEmptyGraph } from 'components/Graph/commands/loadEmptyGraph';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { NetworkViewerIcon } from 'components/Graph/icons/NetworkViewerIcon';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import type { AppTranslations } from 'translations/translations';
import { useConfirmDialog } from 'utils/hooks/useConfirmDialog';

const removedByBreadcrumbClick: GraphBreadcrumbType[] = [
  'path',
  'compareMode',
  'intentCheck',
];

export const getNetworkViewerModeBreadcrumbText = (
  breadcrumb: NetworkViewerModeBreadcrumb,
  msg: AppTranslations,
): string =>
  `${msg.canvasGraph.breadcrumbs.networkViewerMode.label}
  (${msg.canvasGraph.breadcrumbs.networkViewerMode.groupedBy(breadcrumb.groupBy)})`;

export const NetworkViewerModeBreadcrumbItem: FC<
  GraphBreadcrumbProps<NetworkViewerModeBreadcrumb>
> = (props) => {
  const msg = useLocale();

  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  const confirmDialog = useConfirmDialog({
    name: 'NETWORK_VIEWER_MODE_BREADCRUMB',
  });

  return (
    <>
      <confirmDialog.DialogComponent
        msg={msg.canvasGraph.breadcrumbs.confirmMainBreadcrumbClick}
        onClickConfirm={() => {
          ctxProps.dispatch(loadEmptyGraph);
          ctxProps.dispatch(showSidePanel, { networkViewerTabId: 'dataInput' });
        }}
        btnConfirmVariant='primary'
        btnConfirmAccent='positive'
        btnCancelVariant='secondary'
        btnCancelAccent='positive'
      />
      <GraphBreadcrumbContainer
        className='hover__container'
        containerStyle='primary'
        onClick={() => {
          confirmDialog.toggleConfirmDialog();
        }}
        onIndicateRemoveOthers={props.onIndicateRemoveOthers}
        removedByBreadcrumbClick={removedByBreadcrumbClick}
      >
        <NetworkViewerIcon
          title={null}
          variant='dark'
          className='mr-lgu-3 -ml-lgu-2 hover__item--nonhover'
        />
        <NetworkViewerIcon
          title={null}
          variant='coloredLight'
          className='mr-lgu-3 -ml-lgu-2 hover__item--hover'
        />
        <div className='flex flex-col'>
          <span>{msg.canvasGraph.breadcrumbs.networkViewerMode.label}</span>
          <span className='breadcrumbs__breadcrumb-sublabel'>
            (
            {msg.canvasGraph.breadcrumbs.networkViewerMode.groupedBy(
              props.content.groupBy,
            )}
            )
          </span>
        </div>
      </GraphBreadcrumbContainer>
    </>
  );
};
